import { render, staticRenderFns } from "./ReferenceOrganization.vue?vue&type=template&id=1cfb6fc5"
import script from "./ReferenceOrganization.vue?vue&type=script&lang=js"
export * from "./ReferenceOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports